import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Blockquote.module.css';

class Blockquote extends PureComponent {
  render() {
    const { children, color, title, text, border } = this.props;
    const greyBorder = { 'grey-border': border };
    return (
      <div styleName={classNames('wrapper', greyBorder)}>
        <blockquote styleName={classNames('block', color)}>
          <p styleName="title">{title}</p>
          <p styleName="copy">
            {text}
            {children}
          </p>
        </blockquote>
      </div>
    );
  }
}

Blockquote.propTypes = {
  children: PropTypes.node
};

export default Blockquote;
